import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Box } from '../../structural/Box/Box';
import * as styles from './Image.css';
export const Image = _a => {
  var {
    fallbackSrc,
    onError,
    objectFit,
    className
  } = _a,
      allRest = __rest(_a, ["fallbackSrc", "onError", "objectFit", "className"]);

  return _jsx(Box, Object.assign({
    component: "img",
    className: [className, objectFit && styles.objectFit[objectFit]],
    onError: fallbackSrc ? e => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = fallbackSrc;
      onError && onError(e);
    } : undefined
  }, Object.assign({
    width: 'full'
  }, allRest)));
};
const blur = "data:image/svg+xml,%3Csvg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cfilter id='a' x='0' y='0'%3E%3CfeGaussianBlur in='SourceGraphic' stdDeviation='16'/%3E%3C/filter%3E%3C/defs%3E%3Cpath fill='%23CCC' filter='url(%23a)' d='M0 0h32v32H0z'/%3E%3C/svg%3E";
/**
 * @experimental
 */

export const ImagePriority = _a => {
  var {
    fallbackSrc,
    objectFit,
    className,
    onError,
    onLoad
  } = _a,
      allRest = __rest(_a, ["fallbackSrc", "objectFit", "className", "onError", "onLoad"]);

  const [loading, setLoading] = React.useState(true);
  return _jsxs(Box, Object.assign({
    position: "relative",
    className: styles.wrapperPriority
  }, {
    children: [_jsx(Box, Object.assign({
      component: "img",
      className: [className, objectFit && styles.objectFit[objectFit]],
      onError: fallbackSrc ? e => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = fallbackSrc;
        setLoading(false);
        onError && onError(e);
      } : undefined,
      onLoad: e => {
        setLoading(false);
        onLoad && onLoad(e);
      }
    }, Object.assign({
      fetchpriority: 'high'
    }, allRest))), loading && _jsx(Box, {
      component: "img",
      position: "absolute",
      top: 0,
      left: 0,
      width: "full",
      height: "full",
      src: blur
    })]
  }));
};
//# sourceMappingURL=Image.js.map